(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navea-collection-entete"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(barre) {
    if (barre.dataset.naveaPret) return;
    barre.dataset.naveaPret = '1';

    var chips = Array.prototype.slice.call(barre.querySelectorAll('[data-navea-filtre]'));
    var compteur = barre.querySelector('[data-navea-count]');
    var gabarit = compteur ? compteur.textContent.trim() : '';
    var total = parseInt(gabarit.split(/\s+/).pop(), 10) || 0;
    var mot = gabarit.replace(/^\d+\s*/, '').replace(/\s*\d+$/, '').trim();
    var actif = '';

    /* On ne filtre que la grille qui suit cet en-tete : une autre
       grille sur la meme page (recommandations, panier) reste intacte. */
    function grille() {
      var depart = barre.closest('.shopify-section') || barre.closest('.navea-coll') || barre;
      var el = depart;
      while ((el = el.nextElementSibling)) {
        if (el.matches && el.matches('.resource-list, .product-grid')) return el;
        var g = el.querySelector && el.querySelector('.resource-list, .product-grid');
        if (g) return g;
      }
      var parent = depart.parentElement;
      return (parent && parent.querySelector('.resource-list, .product-grid')) || document;
    }

    var cible = null;

    function articles() {
      if (!cible || !cible.isConnected) cible = grille();
      return Array.prototype.slice.call(cible.querySelectorAll('[data-navea-tags]'))
        .map(function (m) {
          var carte = m.closest('.resource-list__item, .product-grid__item, li');
          return carte ? { carte: carte, tags: (m.getAttribute('data-navea-tags') || '').split(/\s+/) } : null;
        })
        .filter(Boolean);
    }

    function appliquer() {
      var liste = articles();
      var vus = 0;
      liste.forEach(function (a) {
        var garde = !actif || a.tags.indexOf(actif) !== -1;
        a.carte.hidden = !garde;
        if (garde) vus++;
      });
      if (compteur) compteur.textContent = vus + ' ' + mot + ' ' + (total || liste.length);
      barre.classList.toggle('navea-coll__filtres--actif', !!actif);
    }

    barre.addEventListener('click', function (e) {
      var b = e.target.closest('[data-navea-filtre]');
      if (!b) return;
      var cle = b.getAttribute('data-navea-filtre');
      actif = actif === cle ? '' : cle;
      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', String(c.getAttribute('data-navea-filtre') === actif));
      });
      appliquer();
    });

    /* La grille peut se completer apres coup (defilement infini) :
       on rejoue le filtre sur ce qui arrive. */
    var g = grille();
    if (g && g !== document && window.MutationObserver) {
      new MutationObserver(function () {
        if (actif) appliquer();
      }).observe(g, { childList: true, subtree: true });
    }

    appliquer();
  }

  function scan() { document.querySelectorAll('[data-navea-filtres]').forEach(init); }
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  scan();
})();

  } catch(e) { console.error(e); }
})();
})();
